import { City } from '../types/City';

export const cities: City[] = [
  // México
  {
    id: 'mexico-city',
    name: 'Ciudad de México',
    country: 'México',
    costOfLiving: 45,
    currency: 'MXN',
    exchangeRate: 1,
    rentIndex: 25,
    groceriesIndex: 30,
    restaurantIndex: 20,
    purchasingPowerIndex: 40,
    icon: '🏛️',
    description: 'Capital cosmopolita con rica historia y cultura vibrante'
  },
  {
    id: 'guadalajara',
    name: 'Guadalajara',
    country: 'México',
    costOfLiving: 35,
    currency: 'MXN',
    exchangeRate: 1,
    rentIndex: 20,
    groceriesIndex: 25,
    restaurantIndex: 18,
    purchasingPowerIndex: 45,
    icon: '🎭',
    description: 'Cuna del mariachi y centro tecnológico de México'
  },
  {
    id: 'cancun',
    name: 'Cancún',
    country: 'México',
    costOfLiving: 50,
    currency: 'MXN',
    exchangeRate: 1,
    rentIndex: 35,
    groceriesIndex: 40,
    restaurantIndex: 45,
    purchasingPowerIndex: 35,
    icon: '🏖️',
    description: 'Paraíso tropical con playas de arena blanca'
  },
  
  // Estados Unidos
  {
    id: 'new-york',
    name: 'Nueva York',
    country: 'Estados Unidos',
    costOfLiving: 100,
    currency: 'USD',
    exchangeRate: 20,
    rentIndex: 100,
    groceriesIndex: 85,
    restaurantIndex: 90,
    purchasingPowerIndex: 80,
    icon: '🗽',
    description: 'La ciudad que nunca duerme, centro financiero mundial'
  },
  {
    id: 'los-angeles',
    name: 'Los Ángeles',
    country: 'Estados Unidos',
    costOfLiving: 85,
    currency: 'USD',
    exchangeRate: 20,
    rentIndex: 90,
    groceriesIndex: 75,
    restaurantIndex: 80,
    purchasingPowerIndex: 75,
    icon: '🎬',
    description: 'Capital del entretenimiento y ciudad de las estrellas'
  },
  {
    id: 'miami',
    name: 'Miami',
    country: 'Estados Unidos',
    costOfLiving: 75,
    currency: 'USD',
    exchangeRate: 20,
    rentIndex: 80,
    groceriesIndex: 70,
    restaurantIndex: 75,
    purchasingPowerIndex: 70,
    icon: '🌴',
    description: 'Vibrante ciudad costera con influencia latina'
  },
  
  // Canadá
  {
    id: 'toronto',
    name: 'Toronto',
    country: 'Canadá',
    costOfLiving: 70,
    currency: 'CAD',
    exchangeRate: 15,
    rentIndex: 75,
    groceriesIndex: 65,
    restaurantIndex: 70,
    purchasingPowerIndex: 75,
    icon: '🍁',
    description: 'Metrópolis multicultural con excelente calidad de vida'
  },
  {
    id: 'vancouver',
    name: 'Vancouver',
    country: 'Canadá',
    costOfLiving: 75,
    currency: 'CAD',
    exchangeRate: 15,
    rentIndex: 80,
    groceriesIndex: 70,
    restaurantIndex: 75,
    purchasingPowerIndex: 70,
    icon: '🏔️',
    description: 'Ciudad costera rodeada de montañas y naturaleza'
  },
  
  // Europa
  {
    id: 'london',
    name: 'Londres',
    country: 'Reino Unido',
    costOfLiving: 90,
    currency: 'GBP',
    exchangeRate: 25,
    rentIndex: 95,
    groceriesIndex: 80,
    restaurantIndex: 85,
    purchasingPowerIndex: 65,
    icon: '🎩',
    description: 'Capital histórica con tradición y modernidad'
  },
  {
    id: 'paris',
    name: 'París',
    country: 'Francia',
    costOfLiving: 85,
    currency: 'EUR',
    exchangeRate: 22,
    rentIndex: 90,
    groceriesIndex: 75,
    restaurantIndex: 80,
    purchasingPowerIndex: 70,
    icon: '🗼',
    description: 'Ciudad del amor y capital mundial de la moda'
  },
  {
    id: 'madrid',
    name: 'Madrid',
    country: 'España',
    costOfLiving: 65,
    currency: 'EUR',
    exchangeRate: 22,
    rentIndex: 60,
    groceriesIndex: 55,
    restaurantIndex: 60,
    purchasingPowerIndex: 65,
    icon: '🏰',
    description: 'Capital real con arte, cultura y vida nocturna vibrante'
  },
  {
    id: 'barcelona',
    name: 'Barcelona',
    country: 'España',
    costOfLiving: 70,
    currency: 'EUR',
    exchangeRate: 22,
    rentIndex: 65,
    groceriesIndex: 60,
    restaurantIndex: 65,
    purchasingPowerIndex: 60,
    icon: '🏛️',
    description: 'Ciudad mediterránea con arquitectura única'
  },
  
  // Asia
  {
    id: 'tokyo',
    name: 'Tokio',
    country: 'Japón',
    costOfLiving: 95,
    currency: 'JPY',
    exchangeRate: 0.15,
    rentIndex: 85,
    groceriesIndex: 90,
    restaurantIndex: 80,
    purchasingPowerIndex: 75,
    icon: '🗾',
    description: 'Metrópolis futurista que combina tradición y tecnología'
  },
  {
    id: 'singapore',
    name: 'Singapur',
    country: 'Singapur',
    costOfLiving: 88,
    currency: 'SGD',
    exchangeRate: 15,
    rentIndex: 90,
    groceriesIndex: 85,
    restaurantIndex: 75,
    purchasingPowerIndex: 80,
    icon: '🦁',
    description: 'Ciudad-estado moderna y multicultural'
  },
  
  // Oceanía
  {
    id: 'sydney',
    name: 'Sídney',
    country: 'Australia',
    costOfLiving: 80,
    currency: 'AUD',
    exchangeRate: 13,
    rentIndex: 85,
    groceriesIndex: 75,
    restaurantIndex: 70,
    purchasingPowerIndex: 75,
    icon: '🦘',
    description: 'Ciudad portuaria con icónica ópera'
  },
  
  // Medio Oriente
  {
    id: 'dubai',
    name: 'Dubái',
    country: 'Emiratos Árabes Unidos',
    costOfLiving: 72,
    currency: 'AED',
    exchangeRate: 5.5,
    rentIndex: 70,
    groceriesIndex: 65,
    restaurantIndex: 75,
    purchasingPowerIndex: 85,
    icon: '🏗️',
    description: 'Oasis moderno de lujo e innovación'
  },
  
  // Sudamérica
  {
    id: 'buenos-aires',
    name: 'Buenos Aires',
    country: 'Argentina',
    costOfLiving: 35,
    currency: 'ARS',
    exchangeRate: 0.02,
    rentIndex: 25,
    groceriesIndex: 30,
    restaurantIndex: 20,
    purchasingPowerIndex: 40,
    icon: '💃',
    description: 'Capital del tango con arquitectura europea'
  },
  {
    id: 'sao-paulo',
    name: 'São Paulo',
    country: 'Brasil',
    costOfLiving: 40,
    currency: 'BRL',
    exchangeRate: 4,
    rentIndex: 30,
    groceriesIndex: 35,
    restaurantIndex: 25,
    purchasingPowerIndex: 45,
    icon: '🏙️',
    description: 'Metrópolis brasileña, centro financiero y cultural'
  }
];